import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserAvatar from './UserAvatar';

interface ToolHeaderProps {
  toolName: string;
}

export default function ToolHeader({ toolName }: ToolHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="w-full bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm z-50">
      <div className="max-w-full mx-auto px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-3 hover:opacity-90 transition-opacity group"
          >
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-md p-1 border-t-2 border-[#E4002B]">
              <img 
                src="/images/CVX_Logo_NoTagline_RGB.png" 
                alt="Chevron Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-sm font-semibold text-[#0054A4] group-hover:text-[#003A73] transition-colors">OT Operations</span>
          </button>

          <div className="h-8 w-px bg-gray-200"></div>
          
          <div className="flex items-center gap-2">
            <div className="w-1 h-4 bg-[#E4002B] rounded-full"></div>
            <span className="text-sm text-[#0054A4] font-medium">{toolName}</span>
          </div>
        </div>
        <UserAvatar />
      </div>
    </header>
  );
}
